import RBS_LOGO from '../assets/img/rbs.jpeg'
import NEU_LOGO from '../assets/img/NEU_CCIS.jpg'
import RIGOR_LOGO from '../assets/img/rigor-logo.png'
import ARICENT_LOGO from '../assets/img/aricentLogo.jpg'
import BOSE_LOGO from '../assets/img/bose_logo.png'
import OCI_LOGO from '../assets/img/oracle-logo.png'
import BLOOMBERG_LOGO from '../assets/img/bloomberg-logo.png'

export const experiencesData = [
    {
        position: 'Senior Software Engineer',
        company: 'Bloomberg',
        year: 'Sep `25 - Present',
        img: BLOOMBERG_LOGO,
        details: "Senior Software Engineer at Bloomberg"
    },
    {
        position: 'Senior Software Engineer | SDE 3',
        company: 'Oracle',
        year: 'Jan `20 - Sep `25',
        img: OCI_LOGO,
        details: "Senior Software engineer at Oracle Cloud Infrastructure"
    },
    {
        position: 'Cloud Engineer Intern',
        company: 'Bose',
        year: 'May `19 - Aug `19',
        img: BOSE_LOGO,
        details: "Cloud engineer for API integrations for Bose cloud "

    },
    {
        position: 'Front End Engineer',
        company: 'Retail Business Services',
        year: 'Jan `19- May`19',
        img: RBS_LOGO,
        details: "Front End Engineer for R & D "

    },
    {
        position: 'Graduate Teaching Assistant',
        company: 'Northeastern University',
        year: 'Sep `18- Dec `18',
        img: NEU_LOGO,
        details: "TA for  CS1100 - Computer Science &  Applications"

    },
    {
        position: 'Software Engineer',
        company: 'Rigor Solutions',
        year: 'Nov 16- Aug 17',
        img: RIGOR_LOGO,
        details: " Software Engineer for workforce management - timesheet "
    },
    {
        position: 'Software Engineer',
        company: 'Aricent Technologies ',
        year: 'Nov `15- Nov `16',
        img: ARICENT_LOGO,
        details: "Software engineer for Juniper & Coriant Routers "
    },
    // {
    //     position: 'Mentor',
    //     company: 'Xobin',
    //     year: 'Nov `15- Nov `16',
    //     img: XOBIN_LOGO,
    //     details: "Mentor for coding enthusiasts  signed up with Xobin BootCamp"
    // }
]